const trafficDetails = {
  1: {
    method: "GET",
    url: "https://example.com/api/user",
    status: 200,
    request: {
      headers: { "Accept": "application/json", "Authorization": "Bearer ..." },
      query: ""
    },
    response: {
      headers: { "Content-Type": "application/json" },
      body: '{"user":"Alice","role":"admin"}'
    }
  },
  2: {
    method: "POST",
    url: "https://shopdemo.site/auth/login",
    status: 401,
    request: {
      headers: { "Content-Type": "application/json" },
      body: '{"user":"alice"}'
    },
    response: {
      headers: { "Content-Type": "application/json" },
      body: '{"error":"unauthorized"}'
    }
  },
  3: {
    method: "GET",
    url: "https://legacyapp.net/vuln",
    status: 500,
    request: {
      headers: { "Accept": "text/html" },
      query: "id=1"
    },
    response: {
      headers: { "Content-Type": "text/html" },
      body: '<html><body>Error!</body></html>'
    }
  },
  4: {
    method: "PUT",
    url: "https://example.com/profile/edit",
    status: 204,
    request: {
      headers: { "Authorization": "Bearer ..." },
      body: '{"role":"user"}'
    },
    response: {
      headers: {},
      body: ""
    }
  }
};

export default function TrafficInspector({ selectedId }: { selectedId: number | null }) {
  if (!selectedId || !trafficDetails[selectedId]) {
    return (
      <div className="flex-1 flex flex-col justify-center items-center text-muted-foreground text-sm animate-fade-in">
        <div>เลือก traffic ทางซ้ายเพื่อดูรายละเอียด</div>
      </div>
    );
  }

  const d = trafficDetails[selectedId];
  return (
    <div className="flex-1 p-6 bg-card rounded-r-xl border border-border border-l-0 animate-fade-in">
      <div className="mb-2 font-semibold text-lg">{d.method} <span className="text-primary">{d.url}</span></div>
      <div className="mb-3 text-sm text-muted-foreground">Status: <span className={d.status >= 400 ? 'text-destructive' : 'text-green-600 dark:text-green-400'}>{d.status}</span></div>
      <div className="grid md:grid-cols-2 gap-5">
        <div>
          <div className="mb-1 font-semibold">Request Headers</div>
          <pre className="bg-muted rounded p-3 text-xs mb-2 overflow-auto">{JSON.stringify(d.request.headers, null, 2)}</pre>
          {d.request.body && (
            <>
              <div className="mb-1 font-semibold">Request Body</div>
              <pre className="bg-muted rounded p-3 text-xs overflow-auto">{d.request.body}</pre>
            </>
          )}
        </div>
        <div>
          <div className="mb-1 font-semibold">Response Headers</div>
          <pre className="bg-muted rounded p-3 text-xs mb-2 overflow-auto">{JSON.stringify(d.response.headers, null, 2)}</pre>
          {d.response.body && (
            <>
              <div className="mb-1 font-semibold">Response Body</div>
              <pre className="bg-muted rounded p-3 text-xs overflow-auto">{d.response.body}</pre>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
